import { render } from "./GroupedBoxList.vue?vue&type=template&id=69d958dc"
import script from "./GroupedBoxList.vue?vue&type=script&lang=js"
export * from "./GroupedBoxList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__